module.exports = __webpack_public_path__ + "img/remind@2x.aa493de1.png";